import {AppSettings} from '../constants';
import ManageUsers from './Containers/manage-users';
import InviteUser from './Containers/invite-user';
import MyProfile from './Containers/my-profile';

export default [
  {
    path: '/users',
    component: ManageUsers,
    private: true,
    name: 'Users',
    menu: {
      name: 'Users',
      group: 'Admin',
      order: 1,
      subGroup: 'General',
      icons: 'icon-users-ic',
      condition: () => {
        return AppSettings.clientTypeValue !== 'Homeowner';
      }
    }
  },
  {
    path: '/users/inviteuser',
    component: InviteUser,
    name: 'Invite User',
    private: true
  },
  {
    path: '/my-profile',
    component: MyProfile,
    name: 'My Profile',
    private: true
  }
];



// WEBPACK FOOTER //
// ./src/User/routes.js